/** 設問構成の記入例。入力欄が空のときに雛形として差し込む */
export const REPORT_SETTING_JSON_SAMPLE = `{
  "sections": [
    {
      "name": "強みと伸びしろ",
      "type": "question_list",
      "questions": [
        {
          "question": {
            "question_id": "要約シートの question_id",
            "name": "レポートに出す設問名"
          },
          "report": { "type": "comment" }
        }
      ]
    }
  ]
}`;

export interface ParsedReportSettingJson {
  value: Record<string, unknown> | null;
  error: string | null;
}

/**
 * 入力された設問構成を読み取る。
 *
 * 構成の中身が正しいかはサーバー側が判断する。ここで見るのは、
 * サーバーに送れる形（JSONのオブジェクト）になっているかまで。
 */
export function parseReportSettingJson(input: string): ParsedReportSettingJson {
  const trimmed = input.trim();
  if (trimmed.length === 0) {
    return { value: null, error: "設問構成を入力してください" };
  }

  let parsed: unknown;
  try {
    parsed = JSON.parse(trimmed);
  } catch {
    return { value: null, error: "JSON として読み取れません" };
  }

  if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
    return { value: null, error: "設問構成はオブジェクトで指定してください" };
  }

  return { value: parsed as Record<string, unknown>, error: null };
}

/** 保存済みの設問構成を、編集しやすい形に整えて表示する */
export function formatReportSettingJson(
  reportSettingJson: Record<string, unknown>,
): string {
  return JSON.stringify(reportSettingJson, null, 2);
}
